import { render, staticRenderFns } from "./CourseWareDetail.vue?vue&type=template&id=26b91105&scoped=true"
import script from "./CourseWareDetail.vue?vue&type=script&lang=js"
export * from "./CourseWareDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseWareDetail.vue?vue&type=style&index=0&id=26b91105&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b91105",
  null
  
)

export default component.exports